import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import request from './utils/request.js'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/global.css'

Vue.config.productionTip = false

Vue.use(ElementUI, { size: "medium" })

Vue.prototype.request=request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
